import UserStats from './userStats'
import InvoiceStats from './invoiceStats'
import { useState, useEffect } from 'react';
import { useUserContext } from '../../utils/userContext';

function Stats() {
    const [showUserStats, setShowUserStats] = useState(true);
    const { fetchUserStats, userStats, invoiceStats } = useUserContext();

    useEffect(() => {
        fetchUserStats();
    }, []);

    const handleNavigate = (type) => {
        if (type === 'user') setShowUserStats(true);
        if (type === 'invoice') setShowUserStats(false);
    }

    return (
        <div>
            <div>
                <ul className='adStatUl'>
                    <li className='adStatListElement' onClick={() => handleNavigate('user')}>User</li>
                    <li className='adStatListElement' onClick={() => handleNavigate('invoice')}>Rechnungen</li>
                </ul>
            </div>
            {showUserStats && (
                <UserStats userStats={userStats} />
            )}
            {!showUserStats && (
                <InvoiceStats invoiceStats={invoiceStats} />
            )}
        </div>
    );
}

export default Stats;